import { Record } from 'immutable'

export default Record(
  {
    id: null,
    updatedAt: null,
    wroteAt: null,
    noteId: null,
    blockId: null,
    isWriting: false,
  },
  'UserPresence'
)
